<template>
  <div>
    <div class="gains">
      <div class="container-fluid">
        <div class="card gains-prev">
          <h3>{{translation.predition_gains_current}}</h3>
          <div class="progress__bar row">
            <div class="col-md-10 col-sm-10 col-lg-10 col-xs-10">
              <div class="progress__container-in">
                <div
                  class="progress__bar-in"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="bottom"
                  data-trigger="hover"
                  :style="{width: this.first.current/this.first.max*100+'%'}"
                ></div>
              </div>
            </div>
            <div class="col-md-2 col-sm-2 col-lg-2 col-xs-2">
              <div class>
                <a class="progress__present-initial"></a>
                <div class="progress__check-final">{{currency}} {{this.first.current.toFixed(2)}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card gains-prev-all" v-if="!this.stepTwo">
          <h3>{{translation.predition_gains_all_leads}}</h3>
          <div class="progress__bar row">
            <div class="col-md-10 col-sm-10 col-lg-10 col-xs-10">
              <div class="progress__container-in">
                <div
                  class="progress__bar-in"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="bottom"
                  data-trigger="hover"
                  :style="{width: this.recurrent.current/this.recurrent.max*100+'%'}"
                ></div>
              </div>
            </div>
            <div class="col-md-2 col-sm-2 col-lg-2 col-xs-2">
              <div class>
                <a class="progress__present-initial"></a>
                <div
                  class="progress__check-final"
                >{{currency}} {{this.recurrent.current.toFixed(2)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gains-user",
  props: ["leads", "plan", "stepTwoProp", "user"],
  data() {
    return {
      translation: this.$parent.$parent.view.translation.gainsUser,
      currency: null,
      first: {
        max: 1000,
        current: 0
      },
      recurrent: {
        max: 1000,
        current: 0
      },
      stepTwo: false
    };
  },
  methods: {
    calc(leads) {
      let currency = this.$parent.$parent.view.dados_usuario_office.subsidiary
        .currency_code;

      let isAmbassador = this.user.franchise_type == "AMBASSADOR";

      const sum = (ac, user) => {
        if (!user.franchise_network) return ac;

        let commission = 0.3;
        if (isAmbassador) {
          commission = 0.6;
          if (user.child) {
            commission = 0.07;
          }
        }

        const first = this.plan * (1 - (currency == "BRL" ? 0.187 : 0.05));
        const recurrent = first * commission;

        ac.recurrent += recurrent;

        if (!user.child) {
          ac.first += first;
        }

        if (user.grandsons) {
          user.grandsons.map(x => ({ ...x, child: true })).reduce(sum, ac);
        }

        return ac;
      };

      return leads.reduce(sum, { first: 0, recurrent: 0 });
    }
  },
  created() {
    let currencyLabel = this.$parent.$parent.view.dados_usuario_office
      .subsidiary.currency_code;
    if (currencyLabel == "BRL") {
      this.currency = "R$";
    }
    if (currencyLabel == "USD") {
      this.currency = "$";
    }
    if (currencyLabel == "EUR") {
      this.currency = "€";
    }
  },
  mounted() {
    if(this.stepTwoProp) this.stepTwo = true;
    const { first, recurrent } = this.calc(this.leads);
    setTimeout(() => {
      this.first.current = first;
      this.recurrent.current = recurrent;
    }, 1000);
  }
};
</script>

<style scoped lang="scss">
.gains {
  .container-fluid {
    padding-right: 25px;
    padding-left: 25px;
  }
}

.gains-prev {
  margin-bottom: 25px !important;
}
.card {
  margin-bottom: 0;

  h3 {
    width: 90%;
    margin: 0 auto;
  }
}
.progress__bar {
  position: relative;
  margin: 2rem auto;
  width: 90%;

  .progress__check-final {
    margin-left: 15px;
    top: 2px;
    color: #00fdc4;
    font-weight: 700;
  }

  .progress__container-in {
    display: flex;
    width: 100%;
    height: 20px;
    overflow: hidden;
    &:first-child {
      position: absolute;
      background: #e3e8eb;
      border-radius: 10px;
    }
  }

  .progress__container-in .progress__bar-in {
    transition: all 2s;
    height: 100%;
    background: #00fdc4;
    align-self: flex-end;
    position: relative;
    border-radius: 10px;
    width: 0;
    &.all-rounded {
      border-radius: 10px;
    }
  }

  .progress__container-in .progress-premium {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ddd;
    border-left: 1px solid #828181;
    cursor: pointer;
  }
}
@media (max-width: 500px) {
  .links-user,
  .gains-user {
    width: 100% !important;
  }
  .card {
    padding: 1rem 0;
  }
  .progress__bar {
    width: 75%;
    left: -35px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/gainsUser.vue